export default __webpack_public_path__ + "static/media/rounded-active.ef4b63e4.svg";